// src/MindMappingForm.js
import { useState, useEffect,useRef,useContext  } from "react";
import { useNavigate} from "react-router-dom";
import { FaArrowLeftLong } from "react-icons/fa6";
import { UserContext } from "../context/UserContext";
import "./MindMappingForm.css";

const MM_FORM_STORAGE_KEY = "mind-mapping-draft";

const loadDraft = () => {
  try {
    const raw = sessionStorage.getItem(MM_FORM_STORAGE_KEY);
    return raw ? JSON.parse(raw) : {};
  } catch { return {}; }
};

export default function MindMappingForm() {
  const navigate = useNavigate();
  const { user } = useContext(UserContext);
  const isBypassUser = user?.email?.trim().toLowerCase() === "marsmatedemo@gmail.com" || window.location.hostname === "localhost" || window.location.hostname === "127.0.0.1";

  // 🔥 144-BIT TOKEN LOGIC (72 / 72)
  const _draft = loadDraft();

  const [activeStep, setActiveStep] = useState(_draft.activeStep || 0);
  const [maxReachedStep, setMaxReachedStep] = useState(_draft.maxReachedStep || 0);

  /* ----------------------------------------
     1) BASIC INFO
  ---------------------------------------- */
  const [name, setName] = useState(_draft.name || "");
  const [age, setAge] = useState(_draft.age || "");
  const [gender, setGender] = useState(_draft.gender || "");
  const [contact, setContact] = useState(_draft.contact || "");

  /* ----------------------------------------
     2) ACCESSIBILITY (COURSE → DEPARTMENT)
  ---------------------------------------- */
  const [coursesData, setCoursesData] = useState({});
  const [selectedCourse, setSelectedCourse] = useState(_draft.selectedCourse || "");
  const [selectedDepartments, setSelectedDepartments] = useState(_draft.selectedDepartments || []);
  const [searchDept, setSearchDept] = useState("");
  const [selectedDepartmentObj, setSelectedDepartmentObj] = useState(null);
const locationWrapperRef = useRef(null);




  /* ----------------------------------------
     3) ACCEPTABILITY (SECTORS)
  ---------------------------------------- */
  const [sectorData, setSectorData] = useState({
    primary: [],
    secondary: [],
    tertiary: [],
  });

  const [selectedSectorType, setSelectedSectorType] = useState(_draft.selectedSectorType || "");
  const [selectedSector, setSelectedSector] = useState(_draft.selectedSector || "");

  const [affordability, setAffordability] = useState(_draft.affordability || "");

  /* ----------------------------------------
     5) AREA / LOCATION (Dynamic dropdowns)
  ---------------------------------------- */
  const [country, setCountry] = useState(_draft.country || "");
  const [state, setState] = useState(_draft.state || "");
  const [district, setDistrict] = useState(_draft.district || "");
  const [pincode, setPincode] = useState(_draft.pincode || "");

  // These will store the **IDs** (used only for API calls)
  const [countryId, setCountryId] = useState(_draft.countryId || "");
  const [stateId, setStateId] = useState(_draft.stateId || "");
  const [districtId, setDistrictId] = useState(_draft.districtId || "");

  const [countryList, setCountryList] = useState([]);
  const [stateList, setStateList] = useState([]);
  const [districtList, setDistrictList] = useState([]);
  const [pincodeList, setPincodeList] = useState([]);

  // Search input text states (pre-fill display from draft)
  const [searchCountry, setSearchCountry] = useState(_draft.country || "");
  const [searchState, setSearchState] = useState(_draft.state || "");
  const [searchDistrict, setSearchDistrict] = useState(_draft.district || "");
  const [searchPincode, setSearchPincode] = useState(_draft.pincode ? String(_draft.pincode) : "");

  const [showCountryList, setShowCountryList] = useState(false);
  const [showStateList, setShowStateList] = useState(false);
  const [showDistrictList, setShowDistrictList] = useState(false);
  const [showPincodeList, setShowPincodeList] = useState(false);

  // Keyboard-selected index for each suggestion list
  const [countryIndex, setCountryIndex] = useState(-1);
  const [stateIndex, setStateIndex] = useState(-1);
  const [districtIndex, setDistrictIndex] = useState(-1);
  const [pincodeIndex, setPincodeIndex] = useState(-1);
  

  const filteredCountries = Array.isArray(countryList)
    ? countryList.filter((item) =>
        item.name.toLowerCase().includes(searchCountry.toLowerCase())
      )
    : [];

  const filteredStates = Array.isArray(stateList)
    ? stateList.filter((item) =>
        item.name.toLowerCase().includes(searchState.toLowerCase())
      )
    : [];

  const filteredDistricts = Array.isArray(districtList)
    ? districtList.filter((item) =>
        item.name.toLowerCase().includes(searchDistrict.toLowerCase())
      )
    : [];

  const filteredPincodes = Array.isArray(pincodeList)
    ? pincodeList.filter((item) =>
        item.code.toString().includes(searchPincode)
      )
    : [];

  /* ---- selection helpers (click / Enter) ---- */

 const handleBackStep = () => {
  setActiveStep((prevStep) => {
    const targetStep = prevStep - 1;
    return targetStep < 0 ? 0 : targetStep;
  });
};

  const clearForm = () => {
    setActiveStep(0);
    setMaxReachedStep(0);
    setName(""); setAge(""); setGender(""); setContact("");
    setSelectedCourse(""); setSelectedDepartments([]); setSelectedDepartmentObj(null);
    setSelectedSectorType(""); setSelectedSector("");
    setAffordability("");
    setCountry(""); setState(""); setDistrict(""); setPincode("");
    setCountryId(""); setStateId(""); setDistrictId("");
    setSearchCountry(""); setSearchState(""); setSearchDistrict(""); setSearchPincode("");
    setSearchDept("");
    setPersonality({ introvertOrExtrovert: "", thinkingOrFeeling: "", judgingOrPerceiving: "", sensingOrIntuition: "" });
    setGoals([]);
    sessionStorage.removeItem(MM_FORM_STORAGE_KEY);
  };

/*const resetFutureSteps = (fromStep) => {
  if (fromStep < 1) {
    setSelectedCourse("");
    setSelectedDepartments([]);
    setSelectedDepartmentObj(null);
  }

  if (fromStep < 2) {
    setSelectedSectorType("");
    setSelectedSector("");
  }

  if (fromStep < 3) setAffordability("");

  if (fromStep < 4) {
    setCountry("");
    setState("");
    setDistrict("");
    setPincode("");
  }

  if (fromStep < 5) {
    setPersonality({
      introvertOrExtrovert: "",
      thinkingOrFeeling: "",
      judgingOrPerceiving: "",
      sensingOrIntuition: "",
    });
  }

  if (fromStep < 6) setGoals([]);
};
*/



  const handleCountrySelect = (item) => {
    setCountryId(item.id);
    setCountry(item.name); // real selected value
    setSearchCountry(item.name); // show in input
    setShowCountryList(false);
    setCountryIndex(-1);

    // reset dependent fields
    setState("");
    setStateId("");
    setDistrict("");
    setDistrictId("");
    setPincode("");
    setStateList([]);
    setDistrictList([]);
    setPincodeList([]);
  };

  const handleStateSelect = (item) => {
    setStateId(item.id);
    setState(item.name);
    setSearchState(item.name);
    setShowStateList(false);
    setStateIndex(-1);

    setDistrict("");
    setDistrictId("");
    setPincode("");
    setDistrictList([]);
    setPincodeList([]);
  };

  const handleDistrictSelect = (item) => {
    setDistrictId(item.id);
    setDistrict(item.name);
    setSearchDistrict(item.name);
    setShowDistrictList(false);
    setDistrictIndex(-1);

    setPincode("");
    setPincodeList([]);
  };

  const handlePincodeSelect = (item) => {
    setPincode(item.code);
    setSearchPincode(item.code.toString());
    setShowPincodeList(false);
    setPincodeIndex(-1);
  };

  /* ---- keyboard handlers (ArrowUp / ArrowDown / Enter) ---- */

  /*const onCountryKeyDown = (e) => {
    if (!filteredCountries.length) return;

    if (e.key === "ArrowDown") {
      e.preventDefault();
      setShowCountryList(true);
      setCountryIndex((prev) => {
        const newIndex =
          prev + 1 >= filteredCountries.length ? 0 : prev + 1;
        setSearchCountry(filteredCountries[newIndex].name); // preview in input
        return newIndex;
      });
    } else if (e.key === "ArrowUp") {
      e.preventDefault();
      setShowCountryList(true);
      setCountryIndex((prev) => {
        const newIndex =
          prev <= 0 ? filteredCountries.length - 1 : prev - 1;
        setSearchCountry(filteredCountries[newIndex].name);
        return newIndex;
      });
    } else if (e.key === "Enter") {
      e.preventDefault();
      // If some index is active → select that
      if (countryIndex >= 0 && countryIndex < filteredCountries.length) {
        handleCountrySelect(filteredCountries[countryIndex]);
      } else {
        // If exactly one result or exact match → select it
        if (filteredCountries.length === 1) {
          handleCountrySelect(filteredCountries[0]);
        } else {
          const exact = filteredCountries.find(
            (c) =>
              c.name.toLowerCase() === searchCountry.trim().toLowerCase()
          );
          if (exact) handleCountrySelect(exact);
        }
      }
    }
  };*/

 const handleGoalSelect = (id, pair) => {
  setGoals((prev) => {
    // remove both ids of the pair first
    const filtered = prev.filter(
      (g) => g !== pair[0].id && g !== pair[1].id
    );

    // add the selected one
    if (filtered.length >= REQUIRED_GOALS_COUNT) return filtered;

    return [...filtered, id];
  });
};


  /*const onStateKeyDown = (e) => {
    if (!filteredStates.length) return;

    if (e.key === "ArrowDown") {
      e.preventDefault();
      setShowStateList(true);
      setStateIndex((prev) => {
        const newIndex =
          prev + 1 >= filteredStates.length ? 0 : prev + 1;
        setSearchState(filteredStates[newIndex].name);
        return newIndex;
      });
    } else if (e.key === "ArrowUp") {
      e.preventDefault();
      setShowStateList(true);
      setStateIndex((prev) => {
        const newIndex =
          prev <= 0 ? filteredStates.length - 1 : prev - 1;
        setSearchState(filteredStates[newIndex].name);
        return newIndex;
      });
    } else if (e.key === "Enter") {
      e.preventDefault();
      if (stateIndex >= 0 && stateIndex < filteredStates.length) {
        handleStateSelect(filteredStates[stateIndex]);
      } else {
        if (filteredStates.length === 1) {
          handleStateSelect(filteredStates[0]);
        } else {
          const exact = filteredStates.find(
            (s) =>
              s.name.toLowerCase() === searchState.trim().toLowerCase()
          );
          if (exact) handleStateSelect(exact);
        }
      }
    }
  };*/

  /*const onDistrictKeyDown = (e) => {
    if (!filteredDistricts.length) return;

    if (e.key === "ArrowDown") {
      e.preventDefault();
      setShowDistrictList(true);
      setDistrictIndex((prev) => {
        const newIndex =
          prev + 1 >= filteredDistricts.length ? 0 : prev + 1;
        setSearchDistrict(filteredDistricts[newIndex].name);
        return newIndex;
      });
    } else if (e.key === "ArrowUp") {
      e.preventDefault();
      setShowDistrictList(true);
      setDistrictIndex((prev) => {
        const newIndex =
          prev <= 0 ? filteredDistricts.length - 1 : prev - 1;
        setSearchDistrict(filteredDistricts[newIndex].name);
        return newIndex;
      });
    } else if (e.key === "Enter") {
      e.preventDefault();
      if (districtIndex >= 0 && districtIndex < filteredDistricts.length) {
        handleDistrictSelect(filteredDistricts[districtIndex]);
      } else {
        if (filteredDistricts.length === 1) {
          handleDistrictSelect(filteredDistricts[0]);
        } else {
          const exact = filteredDistricts.find(
            (d) =>
              d.name.toLowerCase() === searchDistrict.trim().toLowerCase()
          );
          if (exact) handleDistrictSelect(exact);
        }
      }
    }
  };*/

  /*const onPincodeKeyDown = (e) => {
    if (!filteredPincodes.length) return;

    if (e.key === "ArrowDown") {
      e.preventDefault();
      setShowPincodeList(true);
      setPincodeIndex((prev) => {
        const newIndex =
          prev + 1 >= filteredPincodes.length ? 0 : prev + 1;
        setSearchPincode(filteredPincodes[newIndex].code.toString());
        return newIndex;
      });
    } else if (e.key === "ArrowUp") {
      e.preventDefault();
      setShowPincodeList(true);
      setPincodeIndex((prev) => {
        const newIndex =
          prev <= 0 ? filteredPincodes.length - 1 : prev - 1;
        setSearchPincode(filteredPincodes[newIndex].code.toString());
        return newIndex;
      });
    } else if (e.key === "Enter") {
      e.preventDefault();
      if (pincodeIndex >= 0 && pincodeIndex < filteredPincodes.length) {
        handlePincodeSelect(filteredPincodes[pincodeIndex]);
      } else {
        if (filteredPincodes.length === 1) {
          handlePincodeSelect(filteredPincodes[0]);
        } else {
          const exact = filteredPincodes.find(
            (p) => p.code.toString() === searchPincode.trim()
          );
          if (exact) handlePincodeSelect(exact);
        }
      }
    }
  };*/

useEffect(() => {
  const handleClickOutside = (e) => {
    if (
      locationWrapperRef.current &&
      !locationWrapperRef.current.contains(e.target)
    ) {
      setShowCountryList(false);
      setShowStateList(false);
      setShowDistrictList(false);
      setShowPincodeList(false);

      setCountryIndex(-1);
      setStateIndex(-1);
      setDistrictIndex(-1);
      setPincodeIndex(-1);
    }
  };

  document.addEventListener("mousedown", handleClickOutside);
  return () =>
    document.removeEventListener("mousedown", handleClickOutside);
}, []);

// useEffect(() => {
//   if (activeStep === 4) {
//     if (country) setSearchCountry(country);
//     if (state) setSearchState(state);
//     if (district) setSearchDistrict(district);
//     if (pincode) setSearchPincode(pincode.toString());
//   }
// }, [activeStep, country, state, district, pincode]);


  /* Fetch countries */
  useEffect(() => {
    fetch(`${process.env.REACT_APP_BACKEND_URL}/api/countries`)
      .then((res) => res.json())
      .then((data) => setCountryList(data))
      .catch((err) => console.error("Country fetch error:", err));
  }, []);



  /* When country selected → fetch its states (use countryId) */
  useEffect(() => {
    if (!countryId) return;

    fetch(`${process.env.REACT_APP_BACKEND_URL}/api/states/${countryId}`)
      .then((res) => res.json())
      .then((data) => setStateList(data))
      .catch((err) => console.error("State fetch error:", err));

    // Reset dependent values (safety)
    setState("");
    setStateId("");
    setDistrict("");
    setDistrictId("");
    setPincode("");
    setDistrictList([]);
    setPincodeList([]);
  }, [countryId]);

  /* When state selected → fetch its districts (use stateId) */
  useEffect(() => {
    if (!stateId) return;

    fetch(`${process.env.REACT_APP_BACKEND_URL}/api/districts/${stateId}`)
      .then((res) => res.json())
      .then((data) => setDistrictList(data))
      .catch((err) => console.error("District fetch error:", err));

    setDistrict("");
    setDistrictId("");
    setPincode("");
    setPincodeList([]);
  }, [stateId]);

  /* When district selected → fetch its pincodes (use districtId) */
  useEffect(() => {
    if (!districtId) return;

    fetch(`${process.env.REACT_APP_BACKEND_URL}/api/pincodes/${districtId}`)
      .then((res) => res.json())
      .then((data) => setPincodeList(data))
      .catch((err) => console.error("Pincode fetch error:", err));

    setPincode("");
  }, [districtId]);

  /* ----------------------------------------
     6) PERSONALITY (AWARENESS)
  ---------------------------------------- */
  const [personality, setPersonality] = useState(_draft.personality || {
    introvertOrExtrovert: "",
    thinkingOrFeeling: "",
    judgingOrPerceiving: "",
    sensingOrIntuition: "",
  });

  /* ----------------------------------------
     7) GOALS
  ---------------------------------------- */
  const [goals, setGoals] = useState(_draft.goals || []);
  const REQUIRED_GOALS_COUNT = 6;

const goalPairs = [
  [{ id: 1, name: "Learning & Knowledge" }, { id: 2, name: "Technology & Digital Behavior" }],
  [{ id: 3, name: "Work & Career Habits" }, { id: 4, name: "Money & Finance" }],
  [{ id: 5, name: "Health & Wellness" }, { id: 6, name: "Lifestyle & Daily Routines" }],
  [{ id: 7, name: "Social & Community Behavior" }, { id: 8, name: "Entertainment & Creativity" }],
  [{ id: 9, name: "Shopping & Consumption" }, { id: 10, name: "Problem-Solving & Frustrations" }],
  [{ id: 11, name: "Values & Beliefs" }, { id: 12, name: "Curiosity & Exploration" }],
];



  /*const toggleGoal = (item) => {
    setGoals((prev) =>
      prev.includes(item)
        ? prev.filter((g) => g !== item)
        : [...prev, item]
    );
  };*/

  // Persist draft across login redirects (all state in scope here)
  useEffect(() => {
    try {
      sessionStorage.setItem(MM_FORM_STORAGE_KEY, JSON.stringify({
        activeStep, maxReachedStep, name, age, gender, contact,
        selectedCourse, selectedDepartments,
        selectedSectorType, selectedSector,
        affordability, country, state, district, pincode,
        countryId, stateId, districtId,
        personality, goals,
      }));
    } catch {}
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [activeStep, maxReachedStep, name, age, gender, contact, selectedCourse, selectedDepartments,
      selectedSectorType, selectedSector, affordability, country, state,
      district, pincode, personality, goals]);

  /* ----------------------------------------
     FETCH COURSES
  ---------------------------------------- */
  useEffect(() => {
  fetch(`${process.env.REACT_APP_BACKEND_URL}/api/mind-mapping/courses`)
    .then((res) => res.json())
    .then((data) => {
      const grouped = {};
      data.forEach((item) => {
        if (!grouped[item.graduation_course]) {
          grouped[item.graduation_course] = [];
        }

        grouped[item.graduation_course].push({
          department: item.department,
          course_id: item.id, // 🔥 IMPORTANT
        });
      });
      setCoursesData(grouped);
    });
}, []);


  /* ----------------------------------------
     FETCH SECTORS
  ---------------------------------------- */
  useEffect(() => {
    fetch(`${process.env.REACT_APP_BACKEND_URL}/api/mind-mapping/sectors`)
      .then((res) => res.json())
      .then((data) => {
        setSectorData({
          primary: data.primary,
          secondary: data.secondary,
          tertiary: data.tertiary,
        });
      });
  }, []);

  /* ----------------------------------------
     AUTO STEP MOVEMENT
  ---------------------------------------- */

  // Track the furthest step the user has ever progressed past
  useEffect(() => {
    setMaxReachedStep((prev) => Math.max(prev, activeStep));
  }, [activeStep]);

  // Step 0 → 1 (only on first visit)
useEffect(() => {
  const isValidContact = /^\d{10}$/.test(contact);
  if (activeStep === 0 && activeStep >= maxReachedStep && name.trim().length >= 2 && age && gender && isValidContact) {
    setTimeout(() => setActiveStep(1), 700);
  }
}, [name, age, gender, contact, activeStep, maxReachedStep]);



  // Step 1 → 2 (only on first visit)
  useEffect(() => {
    if (activeStep === 1 && activeStep >= maxReachedStep && selectedCourse && selectedDepartments.length > 0) {
      setTimeout(() => setActiveStep(2), 1000);
    }
  }, [selectedCourse, selectedDepartments, activeStep, maxReachedStep]);

  // Step 2 → 3 (only on first visit)
  useEffect(() => {
    if (activeStep === 2 && activeStep >= maxReachedStep && selectedSector) {
      setTimeout(() => setActiveStep(3), 1000);
    }
  }, [selectedSector, activeStep, maxReachedStep]);

  // Step 3 → 4 (only on first visit)
  useEffect(() => {
    if (activeStep === 3 && activeStep >= maxReachedStep && affordability) {
      setTimeout(() => setActiveStep(4), 1000);
    }
  }, [affordability, activeStep, maxReachedStep]);

  // Step 4 → 5 (AFTER ALL FIELDS FILLED, only on first visit)
  useEffect(() => {
    if (activeStep === 4 && activeStep >= maxReachedStep && country && state && district && pincode) {
      setTimeout(() => setActiveStep(5), 1000);
    }
  }, [country, state, district, pincode, activeStep, maxReachedStep]);

  // Step 5 → 6 (only on first visit)
  useEffect(() => {
    if (
      activeStep === 5 &&
      activeStep >= maxReachedStep &&
      personality.introvertOrExtrovert &&
      personality.thinkingOrFeeling &&
      personality.judgingOrPerceiving &&
      personality.sensingOrIntuition
    ) {
      setTimeout(() => setActiveStep(6), 1000);
    }
  }, [personality, activeStep, maxReachedStep]);

  // ✅ ADD ONLY THIS (do not modify existing code)
  const getCourseId = async (courseName) => {
  const res = await fetch(
    `${process.env.REACT_APP_BACKEND_URL}
      /api/mind-mapping/course-id/${encodeURIComponent(courseName)}`
  );
  const data = await res.json();
  return data.id;
};


  /* ----------------------------------------
     SUBMIT FORM
  ---------------------------------------- */
  const handleSubmit = async () => {
    if (!user) {
      window.dispatchEvent(new CustomEvent("show-guest-auth", { detail: { callback: handleSubmit } }));
      return;
    }

    localStorage.setItem("mind-mapping-access",true)
   let course_id = selectedDepartmentObj?.course_id;

if (!course_id) {
  course_id = await getCourseId(selectedCourse);
}


    const payload = {
      name,
      age,
      gender,
      contact,
      user_id: user.user_id,
      course: selectedCourse,
      departments: selectedDepartments,
      sector: selectedSector,
      sector_type: selectedSectorType,
      affordability,
      country,
      state,
      district,
      pincode,
      trait_intro_extro: personality.introvertOrExtrovert,
      trait_think_feel: personality.thinkingOrFeeling,
      trait_judge_perceive: personality.judgingOrPerceiving,
      trait_sense_intuit: personality.sensingOrIntuition,
      goals,
    };

    fetch(`${process.env.REACT_APP_BACKEND_URL}/api/mind-mapping/submit`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      credentials: "include",
      body: JSON.stringify(payload),
    })
      .then((res) => res.json())
      .then(() => {
        // localStorage.setItem("course_id", course_id);
        // ✅ SAVE SECTOR SELECTION FOR SECTION-B
        localStorage.setItem("selectedSector", selectedSector);
        localStorage.setItem("selectedSectorType", selectedSectorType);

        localStorage.setItem("selectedState", state);
        localStorage.setItem("selectedDistrict", district);
        localStorage.setItem("course_id", course_id);
        localStorage.setItem("selectedStateId", stateId);
        localStorage.setItem("graduation_course", selectedCourse);
        localStorage.setItem("department", selectedDepartments[0]);
        localStorage.setItem("selected_goals", JSON.stringify(goals));

        sessionStorage.removeItem(MM_FORM_STORAGE_KEY);
        const partA = crypto.randomUUID() + crypto.randomUUID();
      const partB = crypto.randomUUID() + crypto.randomUUID();
        navigate(`/mind-mapping/sec-b/${partA}/${partB}`, { replace: true });
      });
  };

  // Prevent UI flash until token is generated
  

  /* ----------------------------------------
     UI SECTIONS
  ---------------------------------------- */
  const renderStep = () => {
    switch (activeStep) {
      /* -------- BASIC INFO -------- */
      case 0: {
        const showContact = name.trim().length >= 2;
        const showAge = showContact && /^\d{10}$/.test(contact);
        const showGender = showAge && !!age;
        return (
          <>
            <h2 className="mindmap-heading">1. Basic Info</h2>

            {/* A. NAME */}
            <h4>A. Full Name</h4>
            <div className="contact-input-wrapper">
              <input
                type="text"
                placeholder="Enter your full name"
                value={name}
                onChange={(e) => setName(e.target.value)}
              />
            </div>

            {/* B. CONTACT — shown after name ≥2 chars */}
            {showContact && (
              <>
                <h4>B. Contact Number</h4>
                <div className="contact-input-wrapper">
                  <input
                    type="tel"
                    placeholder="Enter mobile number"
                    value={contact}
                    maxLength={10}
                    onChange={(e) => setContact(e.target.value.replace(/\D/g, ""))}
                  />
                </div>
              </>
            )}

            {/* C. AGE — shown after 10-digit contact */}
            {showAge && (
              <>
                <h4>C. Age Group</h4>
                <div className="chip-container">
                  {["< 26", "27-32", "33-42", "> 43"].map((item) => (
                    <span
                      key={item}
                      className={`chip ${age === item ? "selected" : ""}`}
                      onClick={() => setAge(item)}
                    >
                      {item}
                    </span>
                  ))}
                </div>
              </>
            )}

            {/* D. GENDER — shown after age selected */}
            {showGender && (
              <>
                <h4>D. Gender</h4>
                <div className="chip-container">
                  {["Male", "Female", "Other"].map((item) => (
                    <span
                      key={item}
                      className={`chip ${gender === item ? "selected" : ""}`}
                      onClick={() => setGender(item)}
                    >
                      {item}
                    </span>
                  ))}
                </div>
              </>
            )}
          </>
        );
      }

      /* -------- ACCESSIBILITY -------- */
      case 1:
        return (
          <>
            <h2 className="mindmap-heading">2. Accessibility</h2>

            <h4>A. Select Course</h4>
            <div className="chip-container">
              {Object.keys(coursesData).map((course) => (
                <span
                  key={course}
                  className={`chip ${
                    selectedCourse === course ? "selected" : ""
                  }`}
                  onClick={() => {
                    setSelectedCourse(course);
                    setSelectedDepartments([]);
                    setSearchDept("");
                  }}
                >
                  {course}
                </span>
              ))}
            </div>

            {selectedCourse && (
              <>
                <h4>B. Select Department</h4>
                {/* <input
                  type="text"
                  className="search-box"
                  placeholder="Search department..."
                  value={searchDept}
                  onChange={(e) => setSearchDept(e.target.value)}
                /> */}

                <div className="chip-container">
                  {coursesData[selectedCourse]
                    .filter((dept) =>
  dept.department.toLowerCase().includes(searchDept.toLowerCase())
)

                    .map((dept) => (
                      <span
                        key={dept.department}
                        className={`chip ${
                          selectedDepartments.includes(dept.department)
                            ? "selected"
                            : ""
                        }`}
                        onClick={() => {
  setSelectedDepartmentObj(dept);  // ✅ store dept + course_id
  setSelectedDepartments([dept.department]); // keep UI logic intact
}}

                      >
                        {dept.department}
                      </span>
                    ))}
                </div>
              </>
            )}
          </>
        );

      /* -------- ACCEPTABILITY -------- */
      case 2:
        return (
          <>
            <h2 className="mindmap-heading">3. Acceptability</h2>

            {/* STEP A — Select Sector Type */}
            <h4>A. Select Sector Type</h4>
            <div className="chip-container">
              {["primary", "secondary", "tertiary"].map((type) => (
                <span
                  key={type}
                  className={`chip ${selectedSectorType === type ? "selected" : ""}`}
                  onClick={() => {
                    setSelectedSectorType(type);
                    setSelectedSector(""); // reset
                  }}
                >
                  {type.charAt(0).toUpperCase() + type.slice(1)}
                </span>
              ))}
            </div>

            {/* STEP B — Show sector list for selected type */}
            {selectedSectorType && (
              <>
                <h4>B. Select Sector</h4>

                <div className="chip-container">
                  {sectorData[selectedSectorType].map((sector) => (
                    <span
                      key={sector}
                      className={`chip ${selectedSector === sector ? "selected" : ""}`}
                      onClick={() => setSelectedSector(sector)}
                    >
                      {sector}
                    </span>
                  ))}
                </div>
              </>
            )}
          </>
        );

      /* -------- AFFORDABILITY -------- */
      case 3:
        return (
          <>
            <h2 className="mindmap-heading">4. Affordability</h2>
            <p>How much amount do you invest to start business?</p>

            <div className="chip-container">
              {["<0.5 M", "1-2 M", "5-7 M", "10-20 M", ">100 Million"].map(
                (item) => (
                  <span
                    key={item}
                    className={`chip ${
                      affordability === item ? "selected" : ""
                    }`}
                    onClick={() => setAffordability(item)}
                  >
                    {item}
                  </span>
                )
              )}
            </div>
          </>
        );

      /* -------- AREA / LOCATION -------- */
      case 4:
        return (
  <>
    <h2 className="mindmap-heading">5. Area / Location</h2>

    {/* 🔥 WRAPPER FOR ALL DROPDOWNS */}
    <div ref={locationWrapperRef}>

      {/* COUNTRY SEARCH */}
      <div className="mindmap-input-group">
        <label>Country</label>

        <input
          type="text"
          className="mindmap-search-box"
          placeholder="Search Country..."
          value={searchCountry}
          onChange={(e) => {
            setSearchCountry(e.target.value);
            setShowCountryList(true);
            setCountryIndex(-1);
          }}
          onFocus={() => setShowCountryList(true)}
        />

        {showCountryList && filteredCountries.length > 0 && (
          <div className="mindmap-suggestion-box">
            {filteredCountries.map((item, index) => (
              <div
                key={item.id}
                className={`mindmap-suggestion-item ${
                  countryIndex === index ? "active" : ""
                }`}
                onMouseEnter={() => setCountryIndex(index)}
                onMouseDown={(e) => {
                  e.preventDefault();
                  handleCountrySelect(item);
                }}
              >
                {item.name}
              </div>
            ))}
          </div>
        )}
      </div>

      {/* STATE SEARCH */}
      {country && (
        <div className="mindmap-input-group">
          <label>State</label>

          <input
            type="text"
            className="mindmap-search-box"
            placeholder="Search State..."
            value={searchState}
            onChange={(e) => {
              setSearchState(e.target.value);
              setShowStateList(true);
              setStateIndex(-1);
            }}
            onFocus={() => setShowStateList(true)}
          />

          {showStateList && filteredStates.length > 0 && (
            <div className="mindmap-suggestion-box">
              {filteredStates.map((item, index) => (
                <div
                  key={item.id}
                  className={`mindmap-suggestion-item ${
                    stateIndex === index ? "active" : ""
                  }`}
                  onMouseEnter={() => setStateIndex(index)}
                  onMouseDown={(e) => {
                    e.preventDefault();
                    handleStateSelect(item);
                  }}
                >
                  {item.name}
                </div>
              ))}
            </div>
          )}
        </div>
      )}

      {/* DISTRICT SEARCH */}
      {state && (
        <div className="mindmap-input-group">
          <label>District</label>

          <input
            type="text"
            className="mindmap-search-box"
            placeholder="Search District..."
            value={searchDistrict}
            onChange={(e) => {
              setSearchDistrict(e.target.value);
              setShowDistrictList(true);
              setDistrictIndex(-1);
            }}
            onFocus={() => setShowDistrictList(true)}
          />

          {showDistrictList && filteredDistricts.length > 0 && (
            <div className="mindmap-suggestion-box">
              {filteredDistricts.map((item, index) => (
                <div
                  key={item.id}
                  className={`mindmap-suggestion-item ${
                    districtIndex === index ? "active" : ""
                  }`}
                  onMouseEnter={() => setDistrictIndex(index)}
                  onMouseDown={(e) => {
                    e.preventDefault();
                    handleDistrictSelect(item);
                  }}
                >
                  {item.name}
                </div>
              ))}
            </div>
          )}
        </div>
      )}

      {/* PINCODE SEARCH */}
      {district && (
        <div className="mindmap-input-group">
          <label>Pincode</label>

          <input
            type="text"
            className="mindmap-search-box"
            placeholder="Search Pincode..."
            value={searchPincode}
            onChange={(e) => {
              setSearchPincode(e.target.value);
              setShowPincodeList(true);
              setPincodeIndex(-1);
            }}
            onFocus={() => setShowPincodeList(true)}
          />

          {showPincodeList && filteredPincodes.length > 0 && (
            <div className="mindmap-suggestion-box">
              {filteredPincodes.map((item, index) => (
                <div
                  key={item.id}
                  className={`mindmap-suggestion-item ${
                    pincodeIndex === index ? "active" : ""
                  }`}
                  onMouseEnter={() => setPincodeIndex(index)}
                  onMouseDown={(e) => {
                    e.preventDefault();
                    handlePincodeSelect(item);
                  }}
                >
                  {item.code}
                </div>
              ))}
            </div>
          )}
        </div>
      )}

    </div>
  </>
);


      /* ------------------ PERSONALITY ------------------ */
      case 5:
        return (
          <>
            <h2 className="mindmap-heading">6. Awareness: Personality</h2>

            {/* INTROVERT / EXTRAVERT */}
            <div className="trait-box">
              <div
                className={`trait-option ${
                  personality.introvertOrExtrovert === "Introvert"
                    ? "selected green"
                    : ""
                }`}
                onClick={() =>
                  setPersonality({
                    ...personality,
                    introvertOrExtrovert: "Introvert",
                  })
                }
              >
                Introvert
              </div>

              <div
                className={`trait-option ${
                  personality.introvertOrExtrovert === "Extrovert"
                    ? "selected green"
                    : ""
                }`}
                onClick={() =>
                  setPersonality({
                    ...personality,
                    introvertOrExtrovert: "Extrovert",
                  })
                }
              >
                Extrovert
              </div>
            </div>

            {/* THINKING / FEELING */}
            <div className="trait-box">
              <div
                className={`trait-option ${
                  personality.thinkingOrFeeling === "Thinking"
                    ? "selected green"
                    : ""
                }`}
                onClick={() =>
                  setPersonality({
                    ...personality,
                    thinkingOrFeeling: "Thinking",
                  })
                }
              >
                Thinking
              </div>

              <div
                className={`trait-option ${
                  personality.thinkingOrFeeling === "Feeling"
                    ? "selected green"
                    : ""
                }`}
                onClick={() =>
                  setPersonality({
                    ...personality,
                    thinkingOrFeeling: "Feeling",
                  })
                }
              >
                Feeling
              </div>
            </div>

            {/* JUDGING / PERCEIVING */}
            <div className="trait-box">
              <div
                className={`trait-option ${
                  personality.judgingOrPerceiving === "Judging"
                    ? "selected green"
                    : ""
                }`}
                onClick={() =>
                  setPersonality({
                    ...personality,
                    judgingOrPerceiving: "Judging",
                  })
                }
              >
                Judging
              </div>

              <div
                className={`trait-option ${
                  personality.judgingOrPerceiving === "Perceiving"
                    ? "selected green"
                    : ""
                }`}
                onClick={() =>
                  setPersonality({
                    ...personality,
                    judgingOrPerceiving: "Perceiving",
                  })
                }
              >
                Perceiving
              </div>
            </div>

            {/* SENSING / INTUITION */}
            <div className="trait-box">
              <div
                className={`trait-option ${
                  personality.sensingOrIntuition === "Sensing"
                    ? "selected green"
                    : ""
                }`}
                onClick={() =>
                  setPersonality({
                    ...personality,
                    sensingOrIntuition: "Sensing",
                  })
                }
              >
                Sensing
              </div>

              <div
                className={`trait-option ${
                  personality.sensingOrIntuition === "Intuition"
                    ? "selected green"
                    : ""
                }`}
                onClick={() =>
                  setPersonality({
                    ...personality,
                    sensingOrIntuition: "Intuition",
                  })
                }
              >
                Intuition
              </div>
            </div>
          </>
        );

      /* ------------------ GOALS + SUBMIT ------------------ */
      /* ------------------ GOALS (TRAIT STYLE) ------------------ */
  /* ------------------ GOALS (LIKE PERSONALITY) ------------------ */
case 6:
  return (
    <>
      <h2 className="mindmap-heading">7. Goals</h2>

      <p style={{ marginBottom: "6px",marginLeft: "10px", color: "#555" }}>
        Select exactly <b>6 goals</b> that describe you
      </p>

      <p
        style={{
          marginBottom: "18px", marginLeft: "10px",
          fontWeight: 500,
          color: goals.length === 6 ? "#16a34a" : "#dc2626",
        }}
      >
        Selected: {goals.length} / 6
      </p>

      {/* GOAL TRAIT BOXES */}
      {goalPairs.map(([left, right]) => (
        <div className="trait-box" key={left.id}>
          <div
            className={`trait-option ${
              goals.includes(left.id) ? "selected green" : ""
            }`}
           onClick={() => handleGoalSelect(left.id, [left, right])}

          >
            {left.name}
          </div>

          <div className="trait-divider" />

          <div
            className={`trait-option ${
              goals.includes(right.id) ? "selected green" : ""
            }`}
           onClick={() => handleGoalSelect(right.id, [left, right])}

          >
            {right.name}
          </div>
        </div>
      ))}

      {/* SUBMIT */}
      <div className="mindmap-submit-wrapper">
        <button
          className="mindmap-submit-btn"
          onClick={handleSubmit}
          disabled={goals.length !== 6}
        >
          Submit
        </button>
      </div>
    </>
  );



      default:
        return null;
    }
  };

  const MM_STEPS = [
    { label: "Basic Info" },
    { label: "Accessibility" },
    { label: "Acceptability" },
    { label: "Affordability" },
    { label: "Area" },
    { label: "Awareness" },
    { label: "Goals" },
  ];

  return (
    <div className="page-wrapper">
      <div className="mindmap-page-header">
        <h1 className="page-title">Mind Mapping Form</h1>
      </div>

      <div className={`mind-container ${showCountryList ? "country-open" : ""}`}>
        <div className="mindmap-heading-row">
          <button
            type="button"
            className="mindmap-back-btn"
            onClick={() => {
              if (activeStep === 0) {
                navigate("/dashboard");
              } else {
                handleBackStep();
              }
            }}
            aria-label={activeStep === 0 ? "Back to Dashboard" : "Go to previous step"}
          >
            <FaArrowLeftLong />
          </button>
          <button
            type="button"
            className="mindmap-close-btn"
            title={!name && !contact && !age ? "Close" : "Clear all entered data"}
            onClick={() => {
              if (!name && !contact && !age) {
                navigate("/dashboard");
              } else {
                clearForm();
              }
            }}
          >✕</button>
        </div>

        {/* Modern Step Progress Bar */}
        <div className="mm-progress-bar">
          {MM_STEPS.map((s, i) => (
            <div
              key={i}
              className={`mm-progress-step${i === activeStep ? ' active' : ''}${i < activeStep ? ' completed' : ''}`}
              onClick={() => { if (i < activeStep) setActiveStep(i); }}
              style={{ cursor: i < activeStep ? 'pointer' : 'default' }}
              title={i < activeStep ? `Jump to ${s.label}` : undefined}
            >
              <div className="mm-progress-dot">
                {i < activeStep ? '✓' : i + 1}
              </div>
              <div className="mm-progress-label">{s.label}</div>
            </div>
          ))}
        </div>

        {renderStep()}

        {activeStep < maxReachedStep && activeStep < 6 && (
          <div className="mindmap-submit-wrapper">
            <button
              className="mindmap-submit-btn"
              onClick={() => setActiveStep((prev) => prev + 1)}
            >
              Next →
            </button>
          </div>
        )}
      </div>
    </div>
  );
}